import React from "react";
import { Deck, Slide } from "spectacle";
import createTheme from "spectacle/lib/themes/default";
import createHashHistory from 'history/createHashHistory'

import Hello from './slides/Hello';
import AboutAltola from './slides/AboutAltola';
import WhoWeAre from "./slides/WhoWeAre";
import OurServices from "./slides/OurServices";
import PartnerBootcamps from "./slides/PartnerBootcamps";
import HeadlessBootcamp from "./slides/HeadlessBootcamp";
import PersonalizationBootcamp from "./slides/PersonalizationBootcamp";
import XConnectBootcamp from "./slides/xConnectBootcamp";
import ValueBootcamps from "./slides/ValueBootcamps";
import TimeAllocationSlide from "./slides/TimeAllocationSlide";
import ExpertAdvisory from "./slides/ExpertAdvisory";
import OurExpertiseCustomers from "./slides/OurExpertiseCustomers";
import OurExpertisePartners from "./slides/OurExpertisePartners";
import Contact from "./slides/Contact";

import bgImage from './images/bg.jpg';
import sfImage from "./images/sf.jpg";
import jssBootcampImage from './images/jss-bootcamp.jpg';
import contactImage from './images/contact.jpg';
import expertiseImage from './images/expertise.jpg';
import expertImage from './images/expert.jpg';
import personalizationBootcampImage from './images/personalization-bootcamp.jpg';
import frostBgImage from './images/Frost.jpg';

import TimeAllocationSlideContent from './content/components/time-allocation';
import ValueBootcampSlideContent from './content/components/value-bootcamp';

const theme = createTheme({
    primary: "#F1FAEE",
    secondary: "#1D3557",
    tertiary: "#457B9D",
    quarternary: "#E63946",
    fifth: "#A8DADC",
    white: "#fff"
},
    {
        primary: { name: "Open Sans", googleFont: true, styles: ["400", "700i"] },
        secondary: "Helvetica"
    });

// TODO: refactor Partner and Customer deck so the history logic will be consolidated
const history = createHashHistory({
    basename: "",
    hashType: "slash",
});

history.listen((location, action) => {
    if (window.gtag) {
        const event = {
            'page_title': location.pathname.replace('/', ''),
            'page_path': `${window.location.pathname}${location.pathname}`
        };
        window.gtag('config', 'UA-117495070-2', event);
    }
});

export default class PartnerDeck extends React.Component {
    render() {
        return (
            <Deck history={history} transition={["zoom", "slide"]} transitionDuration={500} theme={theme} controls={true}>
                <Slide id="hello" transition={["zoom"]} bgImage={bgImage}>
                    <Hello content={{ title: "we have a particular set of skills", subtitle: "Sitecore Boot Camps ⋯ Digital Experience Hackathon ⋯ Expert Advisory" }} />
                </Slide>
                <Slide id="about" transition={["zoom", "slide"]} bgImage={sfImage} bgDarken={0.7}>
                    <AboutAltola />
                </Slide>
                <Slide id="who-we-are" transition={["zoom", "slide"]} bgColor="white">
                    <WhoWeAre />
                </Slide>
                <Slide id="services" transition={["zoom", "slide"]} bgImage={bgImage}>
                    <OurServices />
                </Slide>
                <Slide id="bootcamps" transition={["zoom", "slide"]}>
                    <PartnerBootcamps />
                </Slide>
                <Slide id="headless-bootcamp" transition={["zoom", "slide"]} bgImage={frostBgImage}>
                    <HeadlessBootcamp />
                </Slide>
                <Slide id="personalization-bootcamp" transition={["zoom", "slide"]} bgImage={frostBgImage}>
                    <PersonalizationBootcamp />
                </Slide>
                <Slide id="xconnect-bootcamp" transition={["zoom", "slide"]} bgImage={frostBgImage}>
                    <XConnectBootcamp />
                </Slide>
                <Slide id="value-bootcamps" transition={["zoom", "slide"]} bgImage={bgImage}>
                    <ValueBootcamps content={ValueBootcampSlideContent} />
                </Slide>
                <Slide id="time-allocation" transition={["zoom", "slide"]} bgImage={bgImage}>
                    <TimeAllocationSlide content={TimeAllocationSlideContent} />
                </Slide>
                <Slide id="advisory" transition={["zoom", "slide"]} bgImage={expertImage} bgDarken={0.75}>
                    <ExpertAdvisory />
                </Slide>
                <Slide id="expertise" transition={["zoom", "slide"]} bgImage={expertiseImage} bgDarken={0.75}>
                    <OurExpertiseCustomers />
                </Slide>
                <Slide id="contact" transition={["zoom", "slide"]} bgImage={contactImage} bgDarken={0.75}>
                    <Contact />
                </Slide>
            </Deck>
        );
    }
}


// WEBPACK FOOTER //
// ./src/PartnerDeck.js